// Same for Admin and SuperAdmin
const scheduledBroadcastsTitle: HomePageWidgetTitles['scheduledBroadcasts'] = {
  title: 'Scheduled Broadcasts',
  tooltip:
    'The list of approved broadcasts that will be sent to all users soon',
};

export const AdminTitles: HomePageWidgetTitles = {
  tasks: {
    title: 'My Tasks',
    tooltip: 'The list of Tasks created or updated by you',
  },
  scheduledBroadcasts: scheduledBroadcastsTitle,
  broadcasts: {
    title: 'My Broadcasts',
    tooltip: 'The list of Broadcasts created or updated by you',
  },
  recognitions: {
    title: 'My Recognitions',
    tooltip: 'The list of Recognitions created or updated by you',
  },
};

export const SuperAdminTitles: HomePageWidgetTitles = {
  tasks: {
    title: 'Pending Tasks',
    tooltip: 'The list of Tasks awaiting your approval',
  },
  scheduledBroadcasts: scheduledBroadcastsTitle,
  broadcasts: {
    title: 'Pending Broadcasts',
    tooltip: 'The list of Broadcasts awaiting your approval',
  },
  recognitions: {
    title: 'Pending Recognitions',
    tooltip: 'The list of Recognitions awaiting your approval',
  },
};

/**
 * Used for storing personalization settings of HomePage widgets.
 */
export const homePageWidgetPositions = [
  'cell_0_0',
  'cell_0_1',
  'cell_1_0',
  'cell_1_1',
] as const;
export type HomePageWidgetPosition = (typeof homePageWidgetPositions)[number];

export type HomePageWidgetTitles = Record<
  string,
  { title: string; tooltip: string }
>;

export type HomePageWidgetConfig = Record<
  (typeof homePageWidgetPositions)[number],
  string
>;

export const LOCALSTORAGE_KEY = 'homepageWidgets';
